import styled from 'styled-components';
import ds from 'designsystem';

const Arrow = styled.span`
    width: ${ds.get('metrics.xs')};
    height: ${ds.get('metrics.xs')};
    display: ${props => props.isActive ? 'none' : 'block'};
    border: solid black;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    margin-right: ${ds.get('metrics.base')};
`;

export default Arrow;



// WEBPACK FOOTER //
// ./src/blocks/Arrow/Arrow.js